/**
 * This is the application's routes configuration.
 * Only configure routes in this file.
 * @memberOf Application Module
 * @namespace Application Routes
 */

/**
 * @name config
 * @desc Configures the routes.
 * @param $urlRouterProvider
 * @memberOf Application Module.Application Routes
 * @ngInject
 */
var route = function($urlRouterProvider) {
  // https://github.com/angular-ui/ui-router/wiki/URL-routing
  $urlRouterProvider.rule(function($injector, $location) {
    //what this function returns will be set as the $location.url
    var path = $location.path(), normalized = path.toLowerCase();
    if (path != normalized) {
      //instead of returning a new url string, I'll just change the $location.path directly so I don't have to worry about constructing a new url string and so a new state change is not triggered
      $location.replace().path(normalized);
    }
    // because we've returned nothing, no state change occurs
  });
  // Register the default route.
  $urlRouterProvider.otherwise('/login');
}

export default route;



// WEBPACK FOOTER //
// ./src/app.route.js